export const URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'adc51bd3-8d58-40f3-8eac-4a4e644443d6';
export const MODLCLOSE_TIME = 2.5;
